import { ITableInfinite } from 'components/table/infinite/InfiniteTable.interfaces'
import { TEinvoiceReceived } from '@Arti-zen/package-backoffice'
import { DateTime } from 'luxon'
import { colorByState } from '../EinvoicingCtrl/EinvoicingTable.definitionFields'

export const definitionFields = ({
  onSelect,
}: {
  onSelect: (item: TEinvoiceReceived) => void
}): ITableInfinite<TEinvoiceReceived>['definitionFields'] => {
  return [
    {
      indexName:'companyId',
      label: 'CompanyId',
    },
    {
      indexName: 'invoiceNumber',
      label: 'Numéro de facture',
    },
    {
      indexName: 'sellerName',
      label: 'Nom du vendeur',
    },
    {
      indexName: 'state',
      label: 'Etat',
      format: ({ state }) => <div style={{ backgroundColor: colorByState[state] }}>{state}</div>,
    },
    {
      indexName: 'error',
      label: 'erreur',
      onClick: (item) => !!item.error && onSelect(item),
    },
    {
      indexName: 'createdAt',
      label: 'Date de création',
      format: ({ createdAt }) => {
        const date = new Date(createdAt)
        return DateTime.fromJSDate(date).toFormat('dd/MM/yyyy - HH:mm:ss')
      },
    }
  ]
}

export const firstColumn: ITableInfinite<TEinvoiceReceived>['firstColumn'] = {
  format: () => <></>,
}
